// Format timestamp in Twitter-like style
export function formatTimestamp(createdAt) {
  if (!createdAt) return '';
  
  const postDate = new Date(createdAt);
  const now = new Date();
  const diffMs = now - postDate;
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  
  // If less than 24 hours, show relative time
  if (diffDays < 1) {
    const hours = diffHours;
    const minutes = diffMinutes % 60;
    const seconds = diffSeconds % 60;
    
    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s ago`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s ago`;
    } else {
      return `${seconds}s ago`;
    }
  }
  
  // If 24 hours or older, show formatted date
  const month = String(postDate.getMonth() + 1).padStart(2, '0');
  const day = String(postDate.getDate()).padStart(2, '0');
  const year = postDate.getFullYear();
  
  let hours = postDate.getHours();
  const minutes = String(postDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  
  return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
}
